import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./VerticalNavbar.css";

const sections = ["about", "skills", "timeline", "contact"];

const VerticalNavbar = ({ name }) => {
  const [activeSection, setActiveSection] = useState("about");
  const [indicatorPos, setIndicatorPos] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = document.querySelectorAll("section");
      let currentSection = "about";
      let currentIndex = 0;
      const viewportMiddle = window.scrollY + window.innerHeight / 2;

      sectionElements.forEach((section, index) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        if (
          viewportMiddle >= sectionTop &&
          viewportMiddle < sectionTop + sectionHeight
        ) {
          currentSection = section.getAttribute("id");
          currentIndex = index;
        }
      });

      setActiveSection(currentSection);
      setIndicatorPos(currentIndex);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900 && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [menuOpen]);

  const handleLinkClick = () => {
    if (menuOpen) setMenuOpen(false);
  };

  return (
    <nav className={`vertical-navbar ${menuOpen ? "mobile-open" : ""}`}>
      <div className="mobile-navbar-header">
        <span className="nav-brand">{name}</span>
        <button
          className="mobile-nav-toggle"
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
          type="button"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <ul>
        <motion.div
          className="nav-indicator"
          animate={{ y: indicatorPos * 60 }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
        />

        {sections.map((section) => (
          <li
            key={section}
            className={activeSection === section ? "active" : ""}
          >
            <a href={`#${section}`} onClick={handleLinkClick}>
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default VerticalNavbar;
